import {
  isMuttavatteenSabilType,
  mapHouseholdMembersForApi,
  normalizeWhatsappNo,
  type SabilHouseholdMemberInput,
} from "../sabil-household-members";

/** Map create form values to the additional-only API contract. */
export function transformSabilDataCreate(data: Record<string, unknown>): Record<string, unknown> {
  const next = { ...data };
  if (isMuttavatteenSabilType(String(data.sabilType ?? ""))) {
    next.holderWhatsappNo = normalizeWhatsappNo(data.whatsappNo);
    next.householdMembers =
      mapHouseholdMembersForApi(data.householdMembers as SabilHouseholdMemberInput[] | undefined) ??
      [];
    delete next.whatsappNo;
  } else {
    delete next.householdMembers;
    delete next.whatsappNo;
    delete next.holderWhatsappNo;
  }
  return next;
}
